import React, { useEffect, useState } from 'react'
import InnerBanner from '../../../components/common/InnerBanner'
import { useDispatch, useSelector } from 'react-redux'
import { getServiceKey, getServiceNonKey } from '../../../redux/reducers/servicesSlice'
import { setClearAllDataExceptCategory, setDayNightOptionsForUi, setRecurrenceRule, setSelectCategory, setSelectCategoryOptions, setSelectedService } from '../../../redux/reducers/createOrderSlice'
import DropDownForFrequencies from './DropDownForFrequencies'
import GeneralServiceOrder from './GeneralServiceOrder'
import RegularOrderService from './RegularOrderService'
import { useNavigate } from 'react-router-dom'
import { setLoadingContent } from '../../../redux/reducers/loadingSlice'
export const frequencies = [
  { value: "", option: "Just Once", orderType: "General" },
  { value: 7, option: "Daily", orderType: "Regular" },
  { value: 1, option: "Weekly", orderType: "Regular" },
  { value: 2, option: "Twice Weekly", orderType: "Regular" },
  { value: 3, option: "3 Times a week", orderType: "Regular" },
  { value: 14, option: "Fortnightly", type: 'fortnight', orderType: "Regular" },
  // { value: 30, option: "Monthly", type: 'month', orderType: "Regular" },
];

const OrderBookingMainPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedTime, setSelectedTime] = useState({})
  const { selectedCategory, selectedAddress, recurrenceRule, selectedService } = useSelector((state) => state.createOrderSlice)

  const { keyData } = useSelector((state) => state.services)

  useEffect(() => {
    dispatch(
      getServiceKey({ page: 1, dataPerPage: 20 })
    )
    // dispatch(
    //   getServiceNonKey({ page: 1, dataPerPage: 20 })
    // )

  }, [])
  const recurrenceRuleSet = (data) => {
    dispatch(setRecurrenceRule({ recurrenceRule: { ...recurrenceRule, ...data } }))
  }
  const selectServiceData = (item) => {
    const selectedValue = item.target.value
    setSelectedTime(selectedValue)
    dispatch(setSelectCategory({ selectedCategory: selectedValue?.orderType }))
    dispatch(setSelectCategoryOptions({ selectedCategoryOption: selectedValue }))
    recurrenceRuleSet({ days: [] })
    dispatch(setClearAllDataExceptCategory())
  }

  useEffect(() => {
    if (selectedCategory?.toLowerCase() === 'general') {
      let selectedServiceData = keyData?.filter(item => { return (item?.categoryId?.name?.toLowerCase() === 'general') })

      dispatch(setSelectedService({ selectedService: selectedServiceData }))
      if (selectedServiceData[0]?.isAllowForNightService === "yes" && !recurrenceRule?.timePreferenceObject) {
        dispatch(setDayNightOptionsForUi({
          dayNightOptions: [
            { value: "Day Session", option: "Day Session" },
            { value: "Night Session", option: "Night Session" },]
        }))
      }
      if (selectedServiceData[0]?.isAllowForNightService === "no" && !recurrenceRule?.timePreferenceObject) {
        dispatch(setDayNightOptionsForUi({
          dayNightOptions: [
            { value: "Day Session", option: "Day Session" },
          ]
        }))
      }
    }
    else if (selectedCategory?.toLowerCase() === 'regular') {
      let selectedServiceData = keyData?.filter(item => { return (item?.categoryId?.name?.toLowerCase() === 'regular') })
      dispatch(setSelectedService({ selectedService: selectedServiceData }))
      if (selectedServiceData[0]?.isAllowForNightService === "yes" && !recurrenceRule?.timePreferenceObject) {
        dispatch(setDayNightOptionsForUi({
          dayNightOptions: [
            { value: "Day Session", option: "Day Session" },
            { value: "Night Session", option: "Night Session" },]
        }))
      }
      if (selectedServiceData[0]?.isAllowForNightService === "no" && !recurrenceRule?.timePreferenceObject) {
        dispatch(setDayNightOptionsForUi({
          dayNightOptions: [
            { value: "Day Session", option: "Day Session" },
          ]
        }))
      }
    }
  }, [selectedCategory, selectedTime])
  const changePostalHandler = () => {
    navigate('/formpostal', { state: { serviceType: "order-booking" } })
  }
  useEffect(() => {
    return ()=>dispatch(setLoadingContent([]))
  }, [])
  return (
    <>
      <div className="general-cleaning-sec general-ann">
        <div className="container">
          <InnerBanner />

          <div className="address-change d-flex  align-items-center justify-content-between max-720">
            <div className="general-ann-fld d-flex  align-items-center justify-content-center">
              <img src="/assets/images/Map-pin.png" alt="" />
              <p>
                <b>Postal Code:</b>{selectedAddress?.postalCode}
              </p>
            </div>
            <p className="mb-0 colour-red px16" style={{ cursor: "pointer" }} onClick={changePostalHandler}>Change</p>
          </div>


          <div className="form-select-s max-720">
            <h4 className="colour-red">Select the options required</h4>
            <div className="row">
              <div className="col-md-6" >
                <DropDownForFrequencies
                  label={"How often do you need cleaners?"}
                  options={frequencies}
                  onChange={selectServiceData}
                  selectedTime={selectedTime}
                />
              </div>


            </div>
          </div>
          {
            (selectedCategory?.toLowerCase() === 'general' && selectedService) ?
              (
                <><GeneralServiceOrder /></>
              )
              :
              (selectedCategory?.toLowerCase() === 'regular' && selectedService) ?
                (
                  <><RegularOrderService /></>
                )
                :

                null
          }
        </div>
      </div>

    </>
  )
}

export default OrderBookingMainPage